import * as React from "react";

interface RefProps {
    color?: string;
    size?: number;
    fill?: string
}

export const LayerDown = React.forwardRef<SVGSVGElement, RefProps>(({ color = 'currentColor', size = 32, fill = 'black', ...rest }, ref) => {
    return (
        <svg ref={ref} xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-layers" {...rest}>
            <g transform="scale(0.6) translate(12,12)">
                <line x1="12" y1="5" x2="12" y2="19" />
                <polyline points="19 12 12 19 5 12" />

            </g>
            <g transform="scale(0.8) translate(5,0)">
                <polygon points="12 2 2 7 12 12 22 7 12 2"></polygon>
                <polyline points="2 12 12 17 22 12"></polyline>
            </g>
        </svg>

    );
});

export const LayerUp = React.forwardRef<SVGSVGElement, RefProps>(({ color = 'currentColor', size = 32, fill = 'black', ...rest }, ref) => {
    return (
        <svg ref={ref} xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-layers" {...rest}>
            <g transform="rotate(180, 12,12)">
            <g transform="scale(0.6) translate(12,12)">
                <line x1="12" y1="5" x2="12" y2="19" />
                <polyline points="19 12 12 19 5 12" />

            </g>
            <g transform="scale(0.8) translate(5,0)">
                <polygon points="12 2 2 7 12 12 22 7 12 2"></polygon>
                <polyline points="2 12 12 17 22 12"></polyline>
            </g>
            </g>
        </svg>

    );
});

